<div class="mt-3">
  <app-alerts />
</div>

<div class="bg-white">
  <div #editor [attr.id]="summernoteId"></div>
</div>
